<template>
    <div>
        <Section>
                <div>
                    <FilterBox :item-right="40" inline style="padding: 20px;">
                        <FilterBoxItem>
                            <Input clearable v-model="searchVal" @input="searchName" style="width: 200px" placeholder='店铺名称/POIID'/>
                        </FilterBoxItem>

                    </FilterBox>
                </div>
                <div class="middel-mid">
                    <div class="left">
                        <span><b>参与店铺列表</b></span>
                             <span class="colorA3 ml-5px">(共<b style="color: #3384f7">{{data2.length}}</b>条，已筛选<b style="color: #3384f7">{{filterLen}}</b>条)</span>
                    </div>
                    <div class="right">
                        <span class="colorA3">主题活动名称:</span>
                        <span class="ml-10px mr-20px">{{themeData.actName}}</span>
                        <Button type="primary" @click="addShop">添加参与店铺</Button>    
                    </div>            
                </div>
                <div class="middel-mid">
                    <div class="left">
                        <span class="colorA3 ml-5px mr-10px">全选(已选<b style="color: #3384f7">{{selectedLen}}</b>条)</span>
                        <Button disabled v-show="!btnActive">取消参与店铺</Button>
                        <Button v-show="btnActive" type="error" @click="delModel = true">取消参与店铺</Button>
                    </div>        
                </div>
                <div style="padding: 0 20px 20px">
                <Table :no-data-text="noDate" border :columns="columns" :data="nowdata" @on-selection-change="selsctJoin"></Table>
                <Page :total="dataCount2" :page-size="pageSize2" on-page-size-change="_nowPageSize2" @on-change="changepage2" style="text-align: right; margin-top: 20px"></Page>
            </div>
        </Section>
        <Section>
            <Modal
                v-model="shopModel"
                title="添加参与店铺">
                <div slot="footer" class="model-footer">
                    <div class="footer-left">
                        <span>已选择</span>
                        <span>{{selectStoreLen}}</span>
                    </div>
                    <button class="cancel" @click="shopModel = false">取消</button>
                    <Button :disabled="!saveBtn" type="primary" @click="save">确认添加</Button>
                </div>
                <div class="model-main">
                    <p>
                        <Input v-model="searchModelName" placeholder="搜索店铺名称" @input="searchStore" style="width: 200px" />
                    </p>
                    <div style="padding-top:20px">
                        <Table class="model-table" border :columns="columnsModel" :data="nowShopData" @on-selection-change="joinChange"></Table>
                        <Page :total="dataCount" :page-size="pageSize" on-page-size-change="_nowPageSize" @on-change="changepage" style="text-align: right; margin-top: 20px"></Page>
                    </div>
                </div>
            </Modal>
            <Modal
                v-model="delModel" :width="450">
                <div slot="footer" class="model-footer">
                    <button class="cancel" @click="delModel = false">关闭</button>
                    <Button type="error" @click="cancelJoin">确认取消</Button>
                </div>
                 <div class="modeCenter" style="padding:30px 50px">
                    <p>取消后，主题活动和店铺详情中不出现应该店铺。</p>
                    <p>是否继续 <span>取消</span>?</p>
                </div>
                <div slot="header" class="modelHeader" >
                    <i class="iconfont icon-gantanhao"></i>
                    <span>确认取消</span>
                </div>
            </Modal>
        </Section>
    </div>
</template>

<script>
    import LabelHeader from '@/modules/LabelHeader';

    import menuUtil from '../../../utils/menu-list.js';

    import FilterBox from '@/modules/FilterBox';

    import FilterBoxItem from '@/modules/FilterBoxItem';
	
	import Request from '../../../utils/request.js';
    import qs from 'qs';
    import { Button,Input,Table,Page,Modal} from 'iview';
export default {
    props: ['themeData'],
    data() {
        return {
            title:'',
            remark:'',
            storeData:'',
            searchVal:'',
            noDate:`<div class="noData"><span>暂无参与店铺</span><button onclick='window.noFn()'>点此添加</button></div>`,
            searchModelName:'',
            filterLen:0,
            delModel:false,
            shopModel:false,//弹窗
            saveBtn:false,
            btnActive:false,
            saveBtn:false,//添加店铺按钮
            dataCount:0,//数据总条数
            pageSize:10,//每页数据条数
            pageCurrent: 1,//当前页
            ids:[],//存放id 删除用
            selectedLen:0,
            allLength:0,
            nowShopData:'',
            selectStoreLen:0,
            selectStore:[],
            dataCount2:0,//数据总条数
            pageSize2:10,//每页数据条数
            pageCurrent2: 1,//当前页
            nowdata:[],
            searchModelData:[],
            otherData:'',
            columns: [
                    {
                        type: 'selection',
                        maxWidth:100,
                        align: 'center'
                    },
                    {
                        title: '序号',
                        key: 'number',
                        align: 'center',
                        maxWidth:100,
                    },
                    {
                        title: '参与店铺名称',
                        key: 'actName',
                        align: 'center',
                    },
                    {
                        title: 'LOGO',
                        key: 'logo',
                        align: 'center',
                        render:(h,params) =>{
                            if(params.row.logo){
                                return h('img',{attrs:{src: params.row.logo}, style:{
                                    width:'30px',
                                    height:'30px'
                                }})
                            }
                        }
                    },
                    {
                        title: '所在楼层',
                        key: 'site',
                        align: 'center',   
                    },
                    {
                        title: 'POIID',
                        key: 'poiid',
                        align: 'center', 
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth: 150,
                        render: (h, params) => {
                            let btnStyle = {
                                padding: '0 10px'
                            };
                            return h('div', [
                                h('a', {style: btnStyle,on:{
                                    click:()=>{
                                        this.ids.push(params.row.id)
                                        this.cancelJoin()
                                    }
                                }}, '取消参与'),
                            ]);
                        }
                    }
             ],
            columnsModel:[
                {
                    type: 'selection',
                    minWidth: 1,
                    align: 'center'
                },
                {
                    title: '店铺名称',
                    key: 'shopName',
                    align: 'center',
                },
                {
                    title: '所在楼层',
                    key: 'floorName',
                    align: 'center',
                }
            ],
            shopList:[],
            data2:[],
            poiId:[],
            modelShopId:[],
            betweenAry:[],
           
        };
    },

   mounted(){
       let menuObj = menuUtil.getRemark(this.$router.history.current.path);
            this.title = menuObj.menuName;
            this.remark = menuObj.remark;
   },
   components:{
       LabelHeader,
       Button,
       Input,
       FilterBox,
       FilterBoxItem,
       Table,
       Page,
        Modal
   },
   methods:{
       addShop(){
            this.searchModelName = '';
            this.searchStore('');
            this.notCheck();
            this.setDisabled();
            this.shopModel = true;
           
       },
       //表格取消勾选
       notCheck(){
           this.nowShopData.forEach(item =>{
               item._checked = false;
                item._disabled = false
           })
       },
       //保存--添加店铺
       save(){
            this.selectStore = this.betweenAry;
            console.log(this.betweenAry)
           Request.post(`${this.$HOST}/back/joinPoi?buildingId=${this.$route.params.buildingId}&themeId=${this.themeData.id}`,this.selectStore)
           .then(response =>{
               console.log(response)
               if(response.data.code == 0){
                   this.saveBtn = false;
                   this.shopModel = false;
                   this.search();
                   this.$Message.success('添加成功');
               }
           })
           .catch(()=>{
                this.saveBtn = false
                this.shopModel = false
                this.$Message.error('添加失败，请稍后再试');
           })
       },
        //表格勾选
       selsctJoin(selection){
           console.log(selection);
           this.selectedLen = selection.length;
           selection.length > 0 ? this.btnActive = true : this.btnActive = false;
           this.ids.length = 0;
           selection.forEach(item =>{
               this.ids.push(item.id)
           })
       },
        //取消参与--删除
        cancelJoin(){
            console.log(this.ids)
            Request.delete(`${this.$HOST}/back/joinPoi?buildingId=${this.$route.params.buildingId}`,
                {params:{ids:this.ids},paramsSerializer:params =>{return qs.stringify(params,{indices:false})}
                })
            .then(response =>{
				if(response.data.code ==0){
                    this.delModel = false;
                    this.$Message.success('删除成功');
                    this.btnActive = false;
                    this.search();
                }
            })
            .catch(() =>{
                this.$Message.error('删除失败，请稍后再试');
                this.search();
            })
        },
        //参与店铺勾选--弹窗
        joinChange(selection){
            console.log(selection)
            this.selectStoreLen = selection.length;
            this.betweenAry = [];
            this.modelShopId.length = 0;
            selection.forEach(item =>{
                let obj = {
                    poiId:item.POI_ID,
                    floorName:item.floorName,
                    poiName:item.shopName,
                    floorNumber:item.floorNumber,
                    LABEL_X:item.LABEL_X,
                    LABEL_Y:item.LABEL_Y,
                    floorId:item.floorId,

                }
                this.betweenAry.push(obj)
                this.modelShopId.push(item.POI_ID)
            })
           selection.length > 0 ? this.saveBtn = true : this.saveBtn = false;
        },
        //点击分页
        changepage(index){
            //需要显示开始数据的index,(因为数据是从0开始的，页码是从1开始的，需要-1)
            let _start = (index - 1) * this.pageSize;
            //需要显示结束数据的index
            let _end = index * this.pageSize;
            //截取需要显示的数据
            this.nowShopData = this.searchModelData.slice(_start, _end);
            //储存当前页
            this.pageCurrent = index;
  
            this.notCheck();
            this.setChecked();
            this.setDisabled();
        },
        _nowPageSize(index) {
            //实时获取当前需要显示的条数
            this.pageSize = index;
        },
        //点击分页2
        changepage2(index){
            //需要显示开始数据的index,(因为数据是从0开始的，页码是从1开始的，需要-1)
            let _start = (index - 1) * this.pageSize2;
            //需要显示结束数据的index
            let _end = index * this.pageSize2;
            //截取需要显示的数据
            this.nowdata = this.otherData.slice(_start, _end);
            //储存当前页
            this.pageCurrent2 = index;
        },
        _nowPageSize2(index) {
            //实时获取当前需要显示的条数
            this.pageSize2 = index;
        },
        
        //设置弹出表格选中(翻页)
        setChecked(){
            console.log(this.modelShopId)
            this.modelShopId.forEach(item =>{
                this.nowShopData.forEach(el =>{
                    if(item == el.POI_ID){
                        console.log(el)
                        el._checked = true
                    }
                })
            })
        },

        //查询列表
        search(){
            this.nowdata = [];
            this.data2 = [];
            this.poiId = [];
            this.dataCount2 = 0;
            this.selectedLen = 0;
            Request.get(`${this.$HOST}/back/joinPoi?buildingId=${this.$route.params.buildingId}&themeId=${this.themeData.id}`)
            .then(response =>{
                if(response.data.code == 0){
                    this.allLength = response.data.result.length
                    response.data.result.forEach((item,index) =>{
                        let obj = {
                            id:item.id,
                            number:index+1,
                            actName:item.poiName,
                            logo:item.logoUrl,
                            site:item.floorName,
                            poiid:item.poiId,
                        }
                        this.poiId.push(item.poiId)
                        this.data2.push(obj);
                        this.dataCount2 = this.data2.length;//总数据条数
                        this.nowdata = this.data2.slice(0,this.pageSize2);//第一页10条数据 
                        this.otherData = this.data2;
                    })
                }
                
            })
            .catch(() =>{
                this.$Message.error('网络出错，请稍后再试');
            })
        },
        
        //店铺列表
        storeList(){
            let POI;
            if(sessionStorage.getItem('POI') != null){
                let poi = JSON.parse(sessionStorage.getItem('POI'));
                POI = poi.filter(item =>{
                    return item.n !=''
                })
            }
            for(let i = 0 ; i < POI.length ; i++){
                let obj = {
                    POI_ID:POI[i].i,
                    shopName:POI[i].n,
                    floorNumber:POI[i].f, 
                    floorName:POI[i].fn,
                    floorId:POI[i].fi,
                    _checked: false,
                    LABEL_X:POI[i].x,
                    LABEL_Y:POI[i].y,   
                    _disabled:false
                }
                
                this.shopList.push(obj)
            }
           
            this.dataCount = this.shopList.length;//总数据条数
            this.nowShopData = this.shopList.slice(0,this.pageSize);//第一页10条数据 
            this.searchModelData = this.shopList;

        },
        //设置不可勾选
        setDisabled(){
            this.nowShopData.forEach(item =>{
                this.poiId.forEach(el =>{
                    if(item.POI_ID == el){
                        item._disabled = true;
                    }
                })
                
            })
        },
        //模糊搜索店铺名
        searchName(val){
            let searchDaata = this.data2.filter(item =>{
                return item.actName.indexOf(val) > -1 || item.poiid.indexOf(val) > -1
            })
            this.dataCount2 = searchDaata.length;
            this.filterLen = searchDaata.length;
            this.nowdata = searchDaata.slice(0,this.pageSize);
            this.otherData = searchDaata
            if(val == ''){
                this.filterLen = 0
            } 

        },
        //弹窗 模糊搜索
        searchStore(val){
            
            let ModelData = this.shopList.filter(item =>{
                return item.shopName.indexOf(val) > -1
            })
            this.nowShopData = ModelData.slice(0,this.pageSize);
            this.dataCount = ModelData.length;
            this.searchModelData = ModelData;
            this.setDisabled();
        }


   },
   created(){
        //查询列表
        this.search();
        //弹窗-店铺列表
       this.storeList();
        window.noFn = ()=>{
            this.addShop();   
        }  

   },
   

};
</script>

<style lang="less">
    @import '../../../styles/mainTop';
    .middel-mid{
        background-color: #ffffff;
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        border-top: 1px solid #e3e8ee;
        .left{
            float: left;
        }
        .right{
            float: right;
        }
    }
    .model-main{
        max-height:650px;
        overflow:scroll;
        table{
            tbody tr td{
                height: 35px;
            }
            thead tr th{
                height: 30px;
            }
        } 
        
    }
</style>
